module.exports = __webpack_public_path__ + "static/media/8.9c0d22e1.JPG";